// Local images — downloaded once so the site no longer depends on external URLs.
import hero1 from '../assets/images/hero-1.webp';
import hero2 from '../assets/images/hero-2.webp';
import hero3 from '../assets/images/hero-3.webp';
import kidsArt from '../assets/images/kids-art.webp';
import classroom from '../assets/images/classroom.webp';
import playground from '../assets/images/playground.webp';
import teacher from '../assets/images/teacher.webp';
import about from '../assets/images/about.webp';
import parent1 from '../assets/images/parent-1.webp';
import parent2 from '../assets/images/parent-2.webp';
import parent3 from '../assets/images/parent-3.webp';
import parent4 from '../assets/images/parent-4.webp';

const IMG = {
  hero1,
  hero2,
  hero3,
  kidsPlaying: hero3,
  kidsArt,
  kidsNature: hero2,
  kidsReading: hero1,
  classroom,
  playground,
  teacher,
  about,
  admission: hero1,
  parent1,
  parent2,
  parent3,
  parent4,
  gallery: [hero3, kidsArt, classroom, hero2, playground, teacher],
};
export default IMG;
